import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import ControlledCollaborationSidebarProvider from './ControlledCollaborationSidebarProvider';
import LayoutWithCollaborationSidebarInner from './LayoutWithCollaborationSidebarInner';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import useCollaborationSidebarProps from '../hooks/useCollaborationSidebarProps';
import AsyncExpandableCollaborationSidebar from '../features/floatingSidebar/components/ExpandableCollaborationSidebar/AsyncExpandableCollaborationSidebar';
import AsyncCollaborationSidebarDropArea from '../features/floatingSidebar/components/CollaborationSidebarDropArea/AsyncCollaborationSidebarDropArea';
/**
 * This component assumes collaborationSidebarState and
 * onUpdateCollaborationSidebarState are passed in. See
 * LayoutWithCollaborationSidebar for example
 * implementation
 */

export const CONTROLLED_SIDEBAR_ID = 'controlled-sidebar';
export const UNCONTROLLED_SIDEBAR_ID = 'non-controlled-sidebar';
const StyledUIFlex = styled(UIFlex).withConfig({
  displayName: "ControlledLayoutWithCollaborationSidebar__StyledUIFlex",
  componentId: "sc-1hcsq5f-0"
})(["height:100%;"]); // overriding min-width: auto, meaning wide contents
// won't make width wider than container

const PageContents = styled(UIBox).withConfig({
  displayName: "ControlledLayoutWithCollaborationSidebar__PageContents",
  componentId: "sc-1hcsq5f-1"
})(["min-width:0;"]);

function PageLayout({
  children
}) {
  const {
    isControlled,
    pageContentRef,
    noLayout
  } = useCollaborationSidebarProps(); // TODO can we remove need for these?

  const sidebarAndDropArea = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AsyncExpandableCollaborationSidebar, {}), /*#__PURE__*/_jsx(AsyncCollaborationSidebarDropArea, {})]
  });

  if (noLayout) {
    return sidebarAndDropArea;
  }

  return /*#__PURE__*/_jsxs(StyledUIFlex, {
    align: "stretch",
    id: isControlled ? CONTROLLED_SIDEBAR_ID : UNCONTROLLED_SIDEBAR_ID,
    children: [/*#__PURE__*/_jsx(PageContents, {
      ref: pageContentRef,
      grow: 1,
      children: children
    }), sidebarAndDropArea]
  });
}

function ControlledLayoutWithCollaborationSidebar(_ref) {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  const useComposableComponents = props.floating;
  return /*#__PURE__*/_jsx(ControlledCollaborationSidebarProvider, Object.assign({}, props, {
    children: useComposableComponents ? /*#__PURE__*/_jsx(PageLayout, {
      children: children
    }) : /*#__PURE__*/_jsx(LayoutWithCollaborationSidebarInner, {
      children: children
    })
  }));
}

ControlledLayoutWithCollaborationSidebar.defaultProps = {
  isControlled: true
};
export default ControlledLayoutWithCollaborationSidebar;